import axios from 'axios';
import window from 'global';

// preload audio files
const soundFiles = {
  mystery: '/sounds/mystery.mp3',
  click1: '/sounds/click1.mp3',
  click2: '/sounds/click2.mp3',
  click4: '/sounds/click4.mp3',
  click5: '/sounds/click5.mp3',
  tick: '/sounds/tick.mp3',
  tack: '/sounds/tack.mp3',
  toe: '/sounds/toe.mp3',
  fanfare: '/sounds/fanfare.mp3',
  error: '/sounds/error.mp3',
  powerUp: '/sounds/powerUp.mp3',
  magic: '/sounds/magic.mp3',
  keypadError: '/sounds/keypadError.mp3'
};

const buffers: { [key: string]: AudioBuffer } = {};

const AudioContext = window && ((window as any).AudioContext || (window as any).webkitAudioContext);
const context = AudioContext && new AudioContext();

export function preloadAudioFiles(onProgress?: (progress: number, completed: boolean) => void) {
  const filesToPreload = Object.values(soundFiles);
  let completed = 0;

  filesToPreload.forEach(async(filename: string) => {
    if (!context) return;
    const res = await axios.get(filename, { responseType: 'arraybuffer' });
    context.decodeAudioData(res.data, (buffer) => {
      buffers[filename] = buffer;
      completed++;
      onProgress && onProgress(completed / filesToPreload.length, completed === filesToPreload.length);
    });
  });
}

preloadAudioFiles(); // make sure audio files will preload

function playSound(filename: string, volume = 1) {
  if (context) {
    // FIXME: shouldn't we keep the source in memory as well?
    const source = context.createBufferSource();
    source.buffer = buffers[filename];
    const gainNode = context.createGain();
    gainNode.gain.value = volume;
    source.connect(gainNode);
    gainNode.connect(context.destination);
    source.start(0);
  } else {
    (new Audio(filename)).play();
  }
}

export const sounds: { [key: string]: (volume?: number) => void } = {};

for (const prop in soundFiles) {
  sounds[prop] = (volume?: number) => playSound((soundFiles as any)[prop], volume || 1);
}
